<template>

    <div class="flex rounded-md shadow-sm bg-white dark:border-gray-200 dark:border dark:bg-gray-800">
        <div class="flex items-center justify-center w-16 text-sm font-medium text-white bg-white shrink-0 rounded-l-md guide-img-container dark:ring-gray-200 dark:bg-gray-700">
            <a class="font-medium text-gray-900 hover:text-gray-600" :href="`/${show.urlSlug}`" :alt="show.title" :title="show.title" >
            <img :src="show.logo" :alt="`${show.title} logo`" :title="`${show.title} logo`">
            </a>
        </div>
        <div class="flex items-center justify-between flex-1 truncate bg-white border-t border-b border-r border-gray-200 rounded-r-md dark:bg-gray-700">
            <div class="flex-1 px-4 py-2 text-sm truncate">
                <a class="font-medium text-gray-900 hover:text-gray-600"
                   :href="`/${show.urlSlug}`" :alt="show.title" :title="show.title" >
                    {{show.title}}
                </a>
                <p class="text-gray-600 truncate dark:text-gray-400">{{show.category}}</p>
            </div>
        </div>
    </div>
    
</template>

<script lang="ts" setup>
import {defineProps} from "vue";
import {ShowDto} from "@/dtos";

const props = defineProps<{
    show: ShowDto,
}>();

const show: ShowDto = props.show;

</script>
<style>

</style>